import { get } from 'lodash';

const initChartState = {
  isFetching: null,
  options: null,
  idValueDescriptionsMap: null,
};

function drillDownChart(state = {}, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return {};
    case 'INIT_DRILLDOWN':
      return {
        ...state,
        [action.id]: {
          ...initChartState,
          options: [action.defaultOptions[0]],
          isFetching: false,
        },
      };
    case 'UPDATE_CHART_OPTIONS': {
      const options = Object.assign([...state[action.chartId].options], { [action.id]: action.options });

      return { ...state, [action.chartId]: { options } };
    }
    case 'CHART_REQUEST':
      return { ...state, [action.id]: { ...state[action.id], isFetching: true } };
    case 'CHART_REQUEST_DONE':
      return { ...state, [action.id]: { ...state[action.id], isFetching: false } };
    case 'INIT_DETAILS': {
      const opts = get(state, `[${action.id}].options`, []);
      const optsBeforeUpdatedIndex = opts.slice(0, action.i);

      optsBeforeUpdatedIndex[action.i] = action.options;

      return {
        ...state,
        [action.id]: { options: optsBeforeUpdatedIndex },
        idValueDescriptionsMap: action.idValueDescriptionsMap,
        chartTitle: action.title,
      };
    }
    default:
      return state;
  }
}

export default drillDownChart;
